import { CtaButtonType } from '@/lib/interfaces';
import { ReactNode } from 'react';

type CircleButtonProps = {
  height?: string;
  width?: string;
  margin?: string;
  border?: string;
  background?: string;
  addClassStyles?: string;
  type?: CtaButtonType;
  children?: ReactNode;
  onClick?: () => any;
};

export default function CircleButton({
  height = 'h-16',
  width = 'w-16',
  margin = '',
  border = 'border border-black border-opacity-10 dark:border-white dark:border-opacity-40',
  background = '',
  addClassStyles = '',
  type = 'button',
  children,
  onClick,
}: CircleButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`flex items-center justify-center focus:outline-none flex-shrink-0 rounded-full ${margin} ${background} ${height} ${width} ${border} ${addClassStyles}`}
    >
      {children}
    </button>
  );
}
